export const tradeLoyaltyStatuses = {
    BLACKLISTED: 'BLACKLISTED',
    ELIGIBLE: 'ELIGIBLE',
    ENROLLED: 'ENROLLED',
    NOT_ELIGIBLE: 'NOT_ELIGIBLE',
};



// WEBPACK FOOTER //
// ./assets/js/trade/constants.es.js